import React, { useState } from "react";
import axios from "axios";

const RequestLogin = ({ token, user }) => {
  const [details, setDetails] = useState({
    email: "",
    firstName: "",
    lastName: "",
    timesheets: false,
    financialReport: false,
    vacancyOrdering: false
  });
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const sendRequest = async e => {
    setLoading(true);
    e.preventDefault();
    if (!details.email || !details.firstName || !details.email) {
      return;
    }
    await axios
      .post(
        `${process.env.REACT_APP_PROFILE_API_URL}/clientDashboard/candidate/sendLoginRequestEmail`,
        {
          loginRequest: {
            email: details.email,
            firstName: details.firstName,
            lastName: details.lastName,
            client: user.emails[0],
            timesheets: details.timesheets ? "Timesheets" : "",
            financialReport: details.financialReport ? "Financial Report" : "",
            vacancyOrdering: details.vacancyOrdering ? "Vacancy Ordering" : ""
          }
        },
        {
          headers: { Authorization: `Bearer ${token}` }
        }
      )
      .then(() => {
        setMessage(
          "The request has been sent to HR GO and will be dealt with shortly."
        );
        setDetails({
          email: "",
          firstName: "",
          lastName: "",
          timesheets: false,
          financialReport: false,
          vacancyOrdering: false
        });
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
        setMessage("Something went wrong. Please try again later.");
      });
  };

  return (
    <div>
      <h4 className="tw-text-xl tw-py-4 tw-font-bold">Request New Login</h4>
      <p className="tw-pb-4">
        To request a new Client Portal login for a colleague, please complete
        and submit the form below.
      </p>
      <form className="tw-flex tw-mb-4 tw-flex-col" onSubmit={sendRequest}>
        <input
          onChange={e => setDetails({ ...details, email: e.target.value })}
          type="email"
          className="tw-p-1 tw-border-2 tw-border-gray-300 tw-w-72"
          placeholder="Email"
          value={details.email}
        ></input>
        <input
          onChange={e => setDetails({ ...details, firstName: e.target.value })}
          type="text"
          className="tw-p-1 tw-my-1 tw-border-2 tw-border-gray-300 tw-w-72"
          placeholder="First Name"
          value={details.firstName}
        ></input>
        <input
          onChange={e => setDetails({ ...details, lastName: e.target.value })}
          type="text"
          className="tw-p-1 tw-border-2 tw-border-gray-300 tw-w-72"
          placeholder="Last Name"
          value={details.lastName}
        ></input>
        <div className="tw-flex tw-p-2 tw-mt-4 tw-items-center">
          <input
            className="tw-w-4 tw-h-4"
            onClick={() =>
              setDetails({ ...details, timesheets: !details.timesheets })
            }
            checked={details.timesheets}
            type="checkbox"
          />
          <p className="tw-pl-2">Timesheets</p>
        </div>
        <div className="tw-flex tw-p-2 tw-items-center">
          <input
            className="tw-w-4 tw-h-4"
            onClick={() =>
              setDetails({
                ...details,
                financialReport: !details.financialReport
              })
            }
            checked={details.financialReport}
            type="checkbox"
          />
          <p className="tw-pl-2">Financial Report</p>
        </div>
        <div className="tw-flex tw-p-2 tw-items-center">
          <input
            className="tw-w-4 tw-h-4"
            onClick={() =>
              setDetails({
                ...details,
                vacancyOrdering: !details.vacancyOrdering
              })
            }
            checked={details.vacancyOrdering}
            type="checkbox"
          />
          <p className="tw-pl-2">Vacancy Ordering</p>
        </div>

        {message && (
          <p className=" tw-font-bold tw-text-yellow-500">
            The request has been sent to HR GO and will be dealt with shortly.
          </p>
        )}
        <button
          className="btn btn-primary tw-w-36 tw-mt-4 tw-mb-10"
          type="submit"
          disabled={!details.lastName || !details.firstName || !details.email}
        >
          {loading ? "Sending..." : "Send Request"}
        </button>
      </form>
    </div>
  );
};

export default RequestLogin;
